import { Add as AddContact } from './Add';

export default AddContact;
